module.exports = __webpack_public_path__ + "CatConfused-58ee538fe26bdf99da8b2b00cdfe23d5.svg";